// src/toast.js

export function showToast(message, type = 'info') {
  const el = document.createElement('div');
  el.textContent = message;
  el.style.position = 'fixed';
  el.style.right = '16px';
  el.style.bottom = '16px';
  el.style.zIndex = 9999;
  el.style.padding = '10px 12px';
  el.style.borderRadius = '8px';
  el.style.color = '#fff';
  el.style.background = type === 'error' ? '#d33'
                    : type === 'success' ? '#2d7' : '#333';
  el.style.boxShadow = '0 6px 18px rgba(0,0,0,.2)';
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 3000);
}

// Default export adapter so legacy `import toast from './toast'` works
const toast = {
  success: (msg) => showToast(msg, 'success'),
  error:   (msg) => showToast(msg, 'error'),
  info:    (msg) => showToast(msg, 'info'),
};
export default toast;